<template>
  <form class="form-upload" enctype="multipart/form-data" novalidate>
    <div class="dropbox" :class="[{ 'is-dragging': dragging, 'is-dirty': vuelidate.models[uploadFieldName].$dirty, 'is-invalid': vuelidate.models[uploadFieldName].$invalid }]">
      <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files);" accept="image/*" class="input-file" v-if="rerender" @dragenter="dragging=true" @dragend="dragging=false" @dragleave="dragging=false">
      <div class="columns is-gapless is-centered is-vcentered">
        <div class="column">
          <p v-if="isInitial" class="description">
            Drag your file(s) here to begin<br> or click to browse {{ vuelidate.models[uploadFieldName].$params.required ? '*' : '(optional)' }}
          </p>
          <p v-if="isInitial" class="description ie-only">
            Click to browse {{ vuelidate.models[uploadFieldName].$params.required ? '*' : '(optional)' }}
          </p>
          <p v-if="isSaving">
            Previewing {{ fileCount }} files...
          </p>
        </div>
      </div>
    </div>
    <div class="dropbox-overlay" v-if="uploadedFiles && uploadedFiles.length > 0">
      <div class="columns is-gapless is-centered is-vcentered is-multiline">
        <div v-for="fileInfo in uploadedFiles" class="column is-4">
          <img v-if="fileInfo.preview" :src="fileInfo.preview" style="max-width:100%;max-height:140px;margin:auto;" />
          <p v-if="fileInfo.file" style="position:absolute;overflow:hidden;text-overflow:ellipsis;">
            {{ fileInfo.file.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="dropbox-overlay" v-if="isFailed">
      <div class="columns is-gapless is-centered is-vcentered">
        <div class="column">
          Error: {{ uploadError }}
        </div>
      </div>
    </div>
    <div class="dropbox-reset" v-if="isSuccess || isFailed" style="position:absolute;top:15px;right:15px;">
      <a class="button is-primary" href="javascript:void(0)" @click="reset()">
        <i class="fa fa-close"></i>
      </a>
    </div>
    <div v-if="isSuccess && false">
      <p>Uploaded {{ uploadedFiles.length }} file(s) successfully.</p>
      <p>
        <a class="button is-danger" href="javascript:void(0)" @click="reset()">
          reset
        </a>
      </p>
      <ul class="list-unstyled">
        <li v-for="item in uploadedFiles">
          <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
        </li>
      </ul>
    </div>
    <!--FAILED-->
    <div v-if="isFailed && false">
      <p>Uploaded failed.</p>
      <p>
        <a class="button is-danger" href="javascript:void(0)" @click="reset()">
          reset
        </a>
      </p>
      <pre v-if="uploadError">Upload failed: {{ uploadError }}</pre>
    </div>
  </form>
</template>

<script>
  // import { Upload } from '@/apis/Upload'

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    name: 'app',
    props: ['vuelidate', 'is-dirty', 'is-required'],
    data () {
      return {
        rerender: false,
        uploadedFiles: [],
        uploadError: undefined,
        currentStatus: undefined,
        uploadFieldName: 'files',
        fileCount: 0,
        dragging: false,
        data: {
          status: 'ok',
          files: []
        }
      }
    },
    computed: {
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess () {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed () {
        return this.currentStatus === STATUS_FAILED
      }
    },
    methods: {
      reset () {
        var vm = this
        vm.rerender = false
        vm.$nextTick(function () {
          vm.rerender = true
        })

        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.uploadedFiles = []
        this.uploadError = undefined
        this.$emit('files-changed', {
          status: 'initial',
          fieldName: this.uploadFieldName,
          files: [],
          formData: undefined
        })
      },

      save (formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING

        var data = {
          status: 'ok',
          fieldName: this.uploadFieldName,
          files: []
        }
        var index = 0
        for (var pair of formData.entries()) {
          var dataInfo = {
            index: index,
            preview: undefined,
            file: pair[1],
            formData: formData
          }
          data.files[index] = dataInfo
          this.getFilePreview(dataInfo, (index, url) => {
            data.files[index].preview = url
          })
          index++
        }
        data.formData = formData
        this.uploadedFiles = data.files
        this.currentStatus = STATUS_SUCCESS
        this.$emit('files-changed', data)

        // var vm = this
        // Upload(formData)
        //   .then(data => {
        //     // console.log('-- data --')
        //     // console.log(data)
        //     // vm.uploadedFiles = [].concat(data)
        //     data.fieldName = vm.uploadFieldName
        //
        //     for (var i = 0; i < data.files.length; i++) {
        //       var fileInfo = data.files[i]
        //       fileInfo.index = i
        //       fileInfo.preview = undefined
        //       vm.getFilePreview(fileInfo, (index, url) => {
        //         // console.log('-- data url --')
        //         // console.log(index)
        //         data.files[index].preview = url
        //         // vm.$set(data.files[index], 'preview', url)
        //       })
        //     }
        //
        //     if (data.files) {
        //       vm.uploadedFiles = data.files
        //     } else {
        //       vm.uploadedFiles = []
        //     }
        //     vm.currentStatus = STATUS_SUCCESS
        //     vm.$emit('files-changed', data)
        //   })
        //   .catch(error => {
        //     // console.log('-- error --')
        //     // console.log(error)
        //     vm.uploadedFiles = []
        //     vm.uploadError = error.response
        //     vm.currentStatus = STATUS_FAILED
        //     vm.$emit('files-error', error)
        //   })
      },

      filesChange (fieldName, fileList) {
        // console.log('-- files change --')
        // console.log(fieldName)
        // console.log(fileList)
        // console.log(Array(fileList).keys())

        const formData = new FormData()
        if (!fileList.length) return

        this.fileCount = fileList.length

        var errMessage
        if (fileList.length > 3) {
          errMessage = 'Please do not upload more than 3 photos.'
          this.uploadError = errMessage
          this.currentStatus = STATUS_FAILED
          this.$emit('files-error', {
            status: 'invalid_count',
            message: errMessage
          })
          return
        }

        for (var x = 0; x < fileList.length; x++) {
          var file = fileList[x]
          if (file.size > 5242880) {
            errMessage = 'File(s) size exceeded 5MB! // ' + file.size
            this.uploadError = errMessage
            this.currentStatus = STATUS_FAILED
            this.$emit('files-error', {
              status: 'invalid_size',
              message: errMessage
            })
            return
          }

          if (!/\.(jpe?g|png|gif)$/i.test(file.name)) {
            errMessage = 'Invalid file(s) format.'
            this.uploadError = errMessage
            this.currentStatus = STATUS_FAILED
            this.$emit('files-error', {
              status: 'invalid_format',
              message: errMessage
            })
            return
          }
        }

        for (var i = 0; i < fileList.length; i++) {
          formData.append(fieldName + '[' + i + ']', fileList[i], fileList[i].name)
        }

        // for (var pair of formData.entries()) {
        //   console.log('-- part --')
        //   console.log(pair[0])
        //   console.log(pair[1])
        // }
        this.save(formData)
      },

      getFilePreview (fileInfo, onComplete) {
        var file = fileInfo.file
        var reader = new window.FileReader()
        reader.onload = function (event) {
          // console.log('-- onload --')
          // console.log(event)
          let imageDataUrl = event.target.result
          fileInfo.preview = imageDataUrl
          if (onComplete) {
            onComplete(fileInfo.index, imageDataUrl)
          }
        }
        reader.readAsDataURL(file)
      }
    },
    mounted () {
      this.reset()
    }
  }
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";

.form-upload {
  position: relative;

  .columns.is-vcentered {
    height: 100%;
  }

  .dropbox {
    outline: 2px dashed lightgray; /* the dash box */
    outline-offset: -1px;
    background: white;
    color: dimgray;
    // padding: 10px 10px;
    min-height: 200px; /* minimum height */
    height: 250px;
    position: relative;
    cursor: pointer;

    &:hover, &.is-dragging {
      background: $color-white; /* when mouse over to the drop zone, change color */
    }

    &.is-dirty.is-invalid {
      outline-color: $color-red;
    }

    .description {
      display: inline-block;

      &.ie-only {
        display: none;
      }

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: none;

        &.ie-only {
          display: inline-block;
        }
      }
    }
  }

  .dropbox-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.2);
    padding: 30px;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
  }

  .dropbox p {
    font-size: 0.85em;
    text-align: center;
    padding: 30px 0;
  }

}
</style>



// WEBPACK FOOTER //
// FormUpload.vue?fc52f00a